/**
 * @generated SignedSource<<ac105196ca6878943f02bc123f337224>>
 * @relayHash 1664772f62666a6b35dbfe2f37b57d97
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6720b2623a24927dd6af2ca050208fc88fa1b084da49b61d386f7cf2a89f8232

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoard_JiraBoardQuery } from './JiraBoard_JiraBoardQuery.graphql';

import isAssignAgentsInlineM2TechnicalEnabled_provider from '@jira/board__relay-providers/src/AssignAgentsInlineM2TechnicalRelayprovider';
import isAutoManagedSprintsEnabled_provider from '@jira/board__relay-providers/src/AutoManagedSprintsForHarmonisedBoard';
import shouldHandleProjectWithoutBaseIssueType_provider from '@jira/board__relay-providers/src/BoardHandleProjectWithoutBaseIssueType';
import withBoardM3_provider from '@jira/board__relay-providers/src/BoardHarmonisationMilestone3';
import boardInlineAssignAgent_provider from '@jira/board__relay-providers/src/BoardInlineAssignAgent';
import shouldPublishRovoBoardContext_provider from '@jira/board__relay-providers/src/BoardRovoContextualActions';
import withSwimlanesChangeboarding_provider from '@jira/board__relay-providers/src/SwimlanesChangeboarding';
import withTmpHarmonisationOnboarding_provider from '@jira/board__relay-providers/src/TmpHarmonisationOnboarding';

const node: PreloadableConcreteRequest<JiraBoard_JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6720b2623a24927dd6af2ca050208fc88fa1b084da49b61d386f7cf2a89f8232",
    "metadata": {},
    "name": "JiraBoard_JiraBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraboard__relayproviderssrcSwimlanesChangeboardingtsx": withSwimlanesChangeboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcTmpHarmonisationOnboardingtsx": withTmpHarmonisationOnboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAutoManagedSprintsForHarmonisedBoardtsx": isAutoManagedSprintsEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardRovoContextualActionstsx": shouldPublishRovoBoardContext_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardHarmonisationMilestone3tsx": withBoardM3_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAssignAgentsInlineM2TechnicalRelayprovidertsx": isAssignAgentsInlineM2TechnicalEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardInlineAssignAgenttsx": boardInlineAssignAgent_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardHandleProjectWithoutBaseIssueTypetsx": shouldHandleProjectWithoutBaseIssueType_provider
    }
  }
};

export default node;
